/**
 * TealerLab — Deferred perf scripts (extracted from tlr-head inline).
 * - Lazy-load img Klaviyo/Loyoly/Pushowl injectées au runtime
 * - Pause des animations CSS infinies hors écran
 * - Tealer Run pending claim finalize
 */
(function () {
  'use strict';

  // ── PERF: force lazy-loading sur les img Klaviyo/Loyoly/Pushowl
  (function () {
    var THIRD_PARTY_HOSTS = ['cloudfront.net/company', 'assets.loyoly.io', 'assets.klaviyo.com', 'static.klaviyo.com', 'pushowl'];
    function patchImg(img) {
      if (!img || img.dataset.tlrLazied) return;
      var src = img.src || img.getAttribute('data-src') || '';
      var matchesHost = THIRD_PARTY_HOSTS.some(function (h) { return src.indexOf(h) > -1; });
      var matchesParent = img.closest && img.closest('[class*="kl-"], [class*="klaviyo"], [class*="loyoly"], [class*="pushowl"], [class*="lds-"]');
      if (matchesHost || matchesParent) {
        img.loading = 'lazy';
        img.decoding = 'async';
        img.fetchPriority = 'low';
        img.dataset.tlrLazied = '1';
      }
    }
    document.querySelectorAll('img').forEach(patchImg);
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          if (n.tagName === 'IMG') patchImg(n);
          else if (n.querySelectorAll) n.querySelectorAll('img').forEach(patchImg);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  })();

  // ── PERF: pause infinite CSS animations while their element is off-screen
  (function () {
    if (!document.getAnimations || typeof CSSAnimation === 'undefined' || !('IntersectionObserver' in window)) return;
    var OFF = 'tlr-anim-off';
    var MOVES = /^(transform|translate|top|left|right|bottom|inset|margin)/;
    var watched = new WeakSet();
    var groups = new Map();
    // Observe each animated element, not its section: a fixed element in an off-screen section stays visible.
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var els = (groups.get(e.target) || []).filter(function (el) { return el.isConnected; });
        groups.set(e.target, els);
        els.forEach(function (el) { el.classList.toggle(OFF, !e.isIntersecting); });
      });
    }, { rootMargin: '200px 0px' });
    function moves(a) {
      return a.effect.getKeyframes().some(function (k) {
        return Object.keys(k).some(function (p) {
          return MOVES.test(p) && (p !== 'transform' || /translate|matrix/.test(k[p]));
        });
      });
    }
    function isMoving(el) {
      return el.getAnimations().some(function (a) { return a instanceof CSSAnimation && moves(a); });
    }
    // An element animated out of its clipping parent reads as off-screen, freezes there and never comes back: watch a still ancestor.
    function anchorOf(el, a) {
      // A fixed element is not clipped by its parent: its own box tells whether it shows.
      if (!moves(a) || getComputedStyle(el).position === 'fixed') return el;
      var anc = el.parentElement;
      while (anc && anc !== document.body && isMoving(anc)) anc = anc.parentElement;
      return anc || el;
    }
    function infinite(a) {
      return a instanceof CSSAnimation && !!a.effect && a.effect.getComputedTiming().iterations === Infinity;
    }
    function watch(el, a) {
      watched.add(el);
      var anchor = anchorOf(el, a);
      if (groups.has(anchor)) {
        groups.get(anchor).push(el);
        io.unobserve(anchor);
      } else {
        groups.set(anchor, [el]);
      }
      // Re-observing yields a fresh entry, so the whole group settles on one state.
      io.observe(anchor);
    }
    function scan() {
      document.getAnimations().forEach(function (a) {
        if (!infinite(a)) return;
        // Pseudo-element animations report their host element as target.
        var el = a.effect.target;
        if (!el || watched.has(el) || el.getRootNode() !== document) return;
        watch(el, a);
      });
    }
    // cloneNode() copies the pause class onto a node nobody observes: watch it now, keeping it in phase with its original.
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          var list = n.classList.contains(OFF) ? [n] : [];
          list.push.apply(list, n.querySelectorAll('.' + OFF));
          list.forEach(function (el) {
            if (watched.has(el)) return;
            var a = el.getAnimations({ subtree: true }).filter(function (x) { return infinite(x) && x.effect.target === el; })[0];
            if (a) watch(el, a);
            else el.classList.remove(OFF);
          });
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
    scan();
    // Marquee clones are built at load.
    window.addEventListener('load', function () { scan(); setTimeout(scan, 2500); });
    document.addEventListener('shopify:section:load', scan);
  })();

  // ── Tealer Run pending claim finalize (Tokyo freebie)
  (function () {
    var KEY = 'tlr_run_tokyo_pending';
    function readPending() {
      try {
        var raw = sessionStorage.getItem(KEY);
        if (!raw) return null;
        var data = JSON.parse(raw);
        if (!data || !data.aca || (Date.now() - (data.ts || 0)) > 86400000) {
          sessionStorage.removeItem(KEY);
          return null;
        }
        return data;
      } catch (_) { return null; }
    }
    function maybeFinalize() {
      var pending = readPending();
      if (!pending) return;
      fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (c) {
        var total = c.total_price || 0;
        if (total < 100) return;
        sessionStorage.removeItem(KEY);
        window.location.href = '/cart?aca=' + encodeURIComponent(pending.aca);
      }).catch(function () {});
    }
    document.addEventListener('cart:updated', function () { setTimeout(maybeFinalize, 600); });
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { setTimeout(maybeFinalize, 800); });
    } else {
      setTimeout(maybeFinalize, 800);
    }
  })();
})();
